import { DEFAULT_ID } from '@usas/ui-web/utils/Constants';

export const localValidate = (formState) => {
  const errors = {};

  const UNKNOWN_COMPETITION_GENDER_TYPE_ID = 3;

  // Competition Category
  if (formState.competitionGenderTypeId === DEFAULT_ID || formState.competitionGenderTypeId === UNKNOWN_COMPETITION_GENDER_TYPE_ID) {
    errors.competitionGenderTypeId = 'A selection is required';
  }

  return errors;
};

const GenderValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};
export default GenderValidation;